import { ShieldAlert } from 'lucide-react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/dialog';

interface Props {
  aberto: boolean;
  aoFechar: () => void;
  url: string | null;
  mimeType: string | null;
}

/**
 * Visualizador in-app para o advisor — NUNCA `window.open` direto pro link
 * assinado. Trocar por um <img>/<iframe> dentro do próprio app, sem link cru
 * exposto e sem botão de download, é fricção contra o caminho fácil de
 * salvar o documento (clique direito, toolbar nativa do PDF). Não é um
 * cofre: devtools ou print-to-PDF ainda contornam — mas cobre o comum.
 */
export function VisualizadorDeDocumento({ aberto, aoFechar, url, mimeType }: Props) {
  const ehImagem = mimeType?.startsWith('image/') ?? false;
  const ehPdf = mimeType === 'application/pdf';

  return (
    <Dialog open={aberto} onOpenChange={(v) => !v && aoFechar()}>
      <DialogContent className="max-w-4xl h-[85vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldAlert className="w-4 h-4 text-brand shrink-0" />
            Documento protegido — apenas visualização
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 min-h-0 rounded-md bg-muted/30 overflow-hidden flex items-center justify-center">
          {!url ? (
            <p className="text-sm text-muted-foreground">Arquivo não encontrado.</p>
          ) : ehImagem ? (
            <img
              src={url}
              alt="Documento anexado"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
              className="max-w-full max-h-full object-contain select-none"
            />
          ) : ehPdf ? (
            <iframe
              // `#toolbar=0&navpanes=0`: some no visualizador nativo do Chrome a
              // barra que tem o botão de download/impressão. Só funciona em
              // navegadores baseados em Chromium — é reforço, não garantia.
              src={`${url}#toolbar=0&navpanes=0`}
              title="Documento anexado"
              className="w-full h-full border-0"
              onContextMenu={(e) => e.preventDefault()}
            />
          ) : (
            <p className="text-sm text-muted-foreground px-6 text-center">
              Este tipo de arquivo não tem pré-visualização — peça para o médico compartilhar por
              outro meio.
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
